export default __webpack_public_path__ + "static/media/login-banner.6d04baf2.png";